{
  "el": {
    "upload": {
      "labels": {
        "cancelUpload": "Ακύρωση ανεβάσματος",
        "cancelUploadConfirmation": "Θέλεις σίγουρα να ακυρώσεις αυτό το ανέβασμα;",
        "chooseCategory": "Κάνε κλικ για να επιλέξεις πρώτα κατηγορία",
        "defaultMessage": "Πρόσθεσε ή σύρε αρχεία",
        "fallbackMessage": "Το πρόγραμμα περιήγησής σου δεν υποστηρίζει ανέβασμα αρχείων με σύρσιμο.",
        "fallbackText": "Χρησιμοποίησε την εναλλακτική φόρμα παρακάτω για να ανεβάσεις τα αρχεία σου όπως παλιά.",
        "fileTooBig": "Το αρχείο είναι πολύ μεγάλο ({filesize} MB). Μέγιστο μέγεθος: {maxFilesize} MB.",
        "invalidFileType": "Δεν μπορείς να ανεβάσεις αρχεία αυτού του τύπου.",
        "maxFilesExceeded": "Δεν μπορείς να ανεβάσεις άλλα αρχεία.",
        "noExtension": "Το αρχείο δεν έχει επέκταση",
        "rejectedFiles": "Τα παρακάτω αρχεία απορρίφθηκαν:",
        "removeFile": "Αφαίρεση αρχείου",
        "responseError": "Ο διακομιστής απάντησε με κωδικό {statusCode}.",
        "uploadConfirmation": "Το ανέβασμα επιβεβαιώθηκε",
        "uploadError": "Σφάλμα ανεβάσματος",
        "warningMaxFileSize": "Έως {max_files_size} το καθένα"
      }
    }
  }
}
